export class ErrorMessageConstant {
  public static ERROR_EMPTY_OFFICE = 'Office empty'
  public static ERROR_PHONE_LENGTH = 'Số điện thoại không hợp lệ'
  public static ERROR_MAIL_INVALID = 'Email không hợp lệ'
  public static ERROR_NUMBER_INVALID = 'Số nhập vào không hợp lệ'
  public static ERROR_PASSWORD_INVALID = 'Mật khẩu chứa ít nhất một chữ cái viết thường, chữ cái viết hoa, chữ số và kí tự đặc biệt'
  public static ERROR_PASSWORD_CONFIRM = 'Vui lòng nhập chính xác mật khẩu đã nhập ở trên'
  public static ERROR_FILE_EXT_INVALID = 'Vui lòng sử dụng file đúng định dạng (.xlsx, .xls, .csv)'
  public static ERROR_FILE_IMPORT_NOT_TO_THE_SAME_SETTING = 'Vui lòng sử dụng file định dạng đúng với cài đặt'
  public static ERROR_ARRIVAL_CHANGE_STATUS_NOT_BACK = 'Không được đổi về trạng thái trước đó khi đã di chuyển hàng hoá'
  public static ERROR_ARRIVAL_VALIDATE_DATE = 'Thời gian phải lớn hơn ngày hiện tại'
  public static ERROR_ARRIVAL_VALIDATE_DEPARTURE_DATE = 'Thời gian xuất phát phải nhỏ hơn ngày hoàn thành'
  public static ERROR_VALIDATE_NAME_HTML_ZALO = 'Định dạng cho tên tệp HTML đang không chính xác'
  public static ERROR_SYSTEM = 'Đã xảy ra lỗi hệ thống. Xin lỗi về sự bất tiện này.'
}

export class SuccessMessageConstant {
  public static EXPORT_FILE = 'Dữ liệu đã được xuất file thành công.'
}
export const ErrorText = {
  REQUIRED: (prefix = '') =>
    `${prefix} không được để trống.`,
  REQUIRED_WHEN_OTHER_EMPTY: (prefix1 = '', prefix2 = '') =>
      `${prefix1} không được để trống. Do trường ${prefix2} đang để trống.`,
  MIN_LENGTH: (prefix = '', maxLength: number) =>
    `${prefix} không được ít hơn ${maxLength} kí tự`,
  INCLUDES: (prefix1 = '', prefix2 = '') => `Với nơi sử dụng là ${prefix1}, danh sách cột tuỳ chỉnh bắt buộc phải bao gồm: ${prefix2}. Vui lòng thêm vào danh sách cột tuỳ chỉnh.`,
  MAX_LENGTH: (prefix = '', minLength: number) =>
      `${prefix} không được vượt quá ${minLength} kí tự`,
  INVALID: (prefix = '') =>
      `${prefix} định dạng không hợp lệ.`,
  NOT_BEFORE_NOW: (prefix = '') =>
      `${prefix} phải lớn hơn hoặc bằng ngày hiện tại.`,
  NOT_AFTER_DATE: (prefix1 = '', prefix2 = '') =>
      `${prefix1} phải nhỏ hơn hoặc bằng ${prefix2}.`,
  NOT_BEFORE_DATE: (prefix1 = '', prefix2 = '') =>
      `${prefix1} phải lớn hơn hoặc bằng ${prefix2}.`
}

export const SuccessText = {
  DELETE: (prefix1 = '', prefix2 = '') => `${prefix1} ${prefix2} を削除しました。`
}

export const ConfirmText = {
  CONFIRM_REMOVE: (prefix = '') => `Bạn có muốn xoá sản phẩm ${prefix} không ?`
}